<mat-icon *ngIf="job.canStart" [matTooltip]="job.isIdle ? 'Start job' : 'Continue job'"
    (click)="continueJob($event, job)">play_arrow</mat-icon>
<mat-icon *ngIf="job.canStop" matTooltip="Stop job" (click)="stopJob($event, job)">pause</mat-icon>
<app-remove-process-button [process]="job"></app-remove-process-button>
<app-check-process-button [job]="job"></app-check-process-button>
<app-show-task-tab-button [process]="job" *ngIf="showTaskTab"></app-show-task-tab-button>
<div>
    <button class="additional-actions-buttons" mat-button [matMenuTriggerFor]="menu"
        *ngIf="job.isRestartSupported||job.isClearThreadsSupported" (click)="jobMenuClick($event)">
        <mat-icon class="actions-mat-icons">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <div *ngIf="job.isRestartSupported">
            <app-restart-process-button [process]="job" [label]="'Restart'"></app-restart-process-button>
        </div>
        <div *ngIf="job.isRestartSupported">
            <app-configure-process-button [process]="job" [label]="'Reconfigure'">
            </app-configure-process-button>
        </div>
        <div *ngIf="job.isRestartSupported">
            <app-make-process-idle-button [process]="job"></app-make-process-idle-button>
        </div>
        <div *ngIf="job.isClearThreadsSupported">
            <app-clear-process-threads-button [process]="job"
                [label]="'Clear Threads'"></app-clear-process-threads-button>
        </div>
    </mat-menu>
    <app-process-small-spinner [isVisible]="job.isWaitingActionFinish"></app-process-small-spinner>
</div>